import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/login/back.png';
const _hoisted_1 = { class: "login_wechat" };
const _hoisted_2 = { class: "flexColumn-alc flex-jcc" };
const _hoisted_3 = { class: "lw_box" };
import loginForm from './login_form.vue';
import request from '@/api/request';
import feedback from '@/utils/feedback';
import apiUrl from '@/api/apiUrl';
import { encryptAES } from '@/utils/crypto';
import { nextTick, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_forgetPassword',
    emits: ['back'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const loginFormRef = ref();
        const emits = __emit;
        const submitLogin = async (datas) => {
            try {
                const res = await request.post(apiUrl.resetPassword, {
                    mobile: encryptAES(datas.mobile),
                    code: encryptAES(String(datas.code)),
                    password: encryptAES(datas.password),
                });
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    feedback.msgSuccess('重置成功');
                    emits('back');
                }
            }
            catch (err) { }
        };
        const handleBack = () => {
            emits('back');
        };
        const setMobile = (mobile) => {
            nextTick(() => {
                var _a;
                (_a = loginFormRef.value) === null || _a === void 0 ? void 0 : _a.setMobile(mobile);
            });
        };
        __expose({
            setMobile
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", { class: "flexRow-alc lw_back" }, [
                    _createElementVNode("div", {
                        class: "clickable",
                        style: { "width": "25px", "height": "25px", "margin-top": "2px" },
                        onClick: handleBack
                    }, _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                            src: _imports_0,
                            style: { "width": "100%", "height": "100%" }
                        }, null, -1)
                    ])),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "忘记密码", -1))
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(loginForm, {
                            ref_key: "loginFormRef",
                            ref: loginFormRef,
                            showModules: ['code', 'password', 'tips'],
                            btnText: "重置密码",
                            passwordVerify: "",
                            smsType: 3,
                            onSubmit: submitLogin
                        }, null, 512)
                    ])
                ])
            ]));
        };
    }
});
